import { createElement } from "react";
import { readChrome } from "./settings.js";

export function BsgIdOwnsNotice() {
  const chrome = readChrome();
  return createElement(
    "aside",
    { className: "bsg-id-owns", "data-bsg-id-owns": "true" },
    createElement("p", null, "Password and email are managed by BSG ID. Photo and LMS preferences stay here."),
    createElement(
      "a",
      { className: "bsg-id-owns__link", href: chrome.bsgidAccountUrl },
      chrome.bsgidAccountLabel || "BSG ID account",
    ),
  );
}

export default BsgIdOwnsNotice;